<template>

    <card>
        <b-row>
            <b-col cols="8">
                <h3>PMP Status</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table id="pmpstatus-history-table" striped selectable hoverable responsive="true" sort-icon-left
                    :items="pmpstatus" :fields="pmpstatusFields" show-empty
                    @row-clicked="item => $set(item, '_showDetails', !item._showDetails)">
                    <template slot="row-details" slot-scope="row">
                        <b-card>
                            <p>{{ row.item.data }}</p>
                        </b-card>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </card>

</template>

<script lang="ts">
import axios from 'axios';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Table, TableColumn } from "element-ui";
import { PMPStatus } from '@/models/PMPStatus';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: "PMPStatusPage",
    components: {}
})
export default class PMPStatusPage extends Vue {
    private pmpstatus?: PMPStatus[] = [new PMPStatus()];


    private pmpstatusFields = [
        { key: 'stateID', label: 'State', sortable: true },
        { key: 'frequency', label: 'Frequency', sortable: true },
        { key: 'dateSubmitted', label: 'Last Submission', sortable: true }
    ];


    created() {
        this.getPMPStatus();
    }

    getPMPStatus() {
        axios.get(`/Prescription/pmpstatus`)
            .then(response => {
                this.pmpstatus = response.data;
            })
            .catch(error => {
                console.error('Error while getting PMP Status reports', { error, response: error?.response })
                this.$notification(NotificationOptions.error(error));
            });
    }
}

</script>